import "./extensions/index";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import Main from "./main";
import { initMoment } from "./startup/setupMoment";
import { initMarkdown } from "./startup/setupMarkdown";
import LoginPage from "./pages/login";

// moment.js einrichten.
initMoment();

// Markdown einrichten.
initMarkdown();

var container = document.getElementById("app-main");
var loginContainer = document.getElementById("app-login");
if (container)
{
    ReactDOM.render((
        <BrowserRouter>
            <Route component={Main} />
        </BrowserRouter>
    ), container);
}
else if (loginContainer)
{
    ReactDOM.render((
        <BrowserRouter>
            <Route component={LoginPage} />
        </BrowserRouter>
    ), loginContainer);
}